module.exports = __webpack_public_path__ + "img/bayer-plataforma-de-cadastro-medicos.18503c50.jpg";